module.exports = __webpack_public_path__ + "img/login-left.5945eb2b.png";